import { toQueryString } from '@/utils/parsers/QueryString';
import { TreeNode } from '../../utils/normalizers/TreeNormalizer';
import { ProductQualityFilterEnum } from '@c2b/muven-commons'
import { IFilterInformationBooleanWrapper } from '../../utils/interfaces/FilterInformationInterface';
import { BrandModel } from '../../brand/models/BrandModel';
import { IFilter } from '../../utils/interfaces/FilterInterface';

interface ProductQualityWrapper {
    enum: ProductQualityFilterEnum;
    description: string;
}

export class ProductBatchItemListFilterModel implements IFilter {
    static getQualityList(): ProductQualityWrapper[] {
        return [
            {
                enum: ProductQualityFilterEnum.WithImage,
                description: 'Com imagem',
            },
            {
                enum: ProductQualityFilterEnum.WithOutImage,
                description: 'Sem imagem',
            },
            {
                enum: ProductQualityFilterEnum.WithSellPrice,
                description: 'Com preço de venda',
            },
            {
                enum: ProductQualityFilterEnum.WithOutSellPrice,
                description: 'Sem preço de venda',
            },
            {
                enum: ProductQualityFilterEnum.WithWeight,
                description: 'Com peso',
            },
            {
                enum: ProductQualityFilterEnum.WithOutWeight,
                description: 'Sem peso',
            },
            {
                enum: ProductQualityFilterEnum.WithVariation,
                description: 'Com variações',
            },
            {
                enum: ProductQualityFilterEnum.WithOutVariation,
                description: 'Sem variações',
            },
            {
                enum: ProductQualityFilterEnum.WithBrand,
                description: 'Com marca',
            },
            {
                enum: ProductQualityFilterEnum.WithOutBrand,
                description: 'Sem marca',
            },
            {
                enum: ProductQualityFilterEnum.WithEan,
                description: 'Com código EAN',
            },
            {
                enum: ProductQualityFilterEnum.WithOutEan,
                description: 'Sem código EAN',
            },
        ]
    }

    idSource:string = ''
    codeSource:string = ''
    idExternalChannel:string = ''
    isActive: IFilterInformationBooleanWrapper|null = null
    name:string = ''
    skuCode:string = ''
    eanCode:string = ''
    description:string = ''
    categoryList:TreeNode[] = []
    brandList:BrandModel[] = []
    qualityList:ProductQualityWrapper[] = []

    constructor(p?:Partial<ProductBatchItemListFilterModel>) {
        Object.assign(this, p)
    }
    
    addToCategoryList(cat: TreeNode):void {
        this.categoryList.push({
            id: cat.id,
            depth: 0,
            name: cat.name,
        })
    }

    addToBrandList(b: BrandModel):void {
        this.brandList.push({
            id: b.id,
            name: b.name,
        } as BrandModel)
    }
    
    isFilterFilled():boolean {
        return !!this.idSource ||
               !!this.codeSource ||
               !!this.idExternalChannel ||
               !!this.name || 
               !!this.skuCode || 
               !!this.eanCode || 
               !!this.description ||
               !!this.categoryList.length ||
               !!this.brandList.length ||
               !!this.qualityList.length ||
               !!(this.isActive)
    }

    toQueryString():string {
        const tmp = {
            ...this,
            isActive: !!this.isActive ? this.isActive.bool : undefined,
            brandList: this.brandList.map((b) => {
                return b.id
            }),
            categoryList: this.categoryList.map((c) => {
                return c.id
            }),
            qualityList: this.qualityList.map((q) => {
                return q.enum
            }),
        }

        return toQueryString(tmp)
    }
}
